module.exports = __webpack_public_path__ + "img/homeinitddd.33c3f8ab.png";